import { BackButton } from '@components/buttons';
import AddAssetPurchaseOrderForm from 'modules/asset-purchase-order/components/AddAssetPurchaseOrderForm/AddAssetPurchaseOrderForm';
import AddClientInstallationForm from 'modules/client-installation/components/AddClientInstallationForm/AddClientInstallationForm';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';

const AddAssetPurchaseOrderPage = () => {
    return (
        <PageTemplate>
            {/* <BackButton to={`/client-installations`} /> */}
            <PageHeading>
                <div className="flex gap-2">Add Purchase Order</div>
            </PageHeading>

            <AddAssetPurchaseOrderForm />
        </PageTemplate>
    );
};

export default AddAssetPurchaseOrderPage;
